import { orderBy } from 'lodash';
import { QuoteSort } from '../../../../../../common';
import { QuotePlanSchema } from '../../../server/map-quotes';

export const onSort = (selectedSort: string, filteredQuotes: QuotePlanSchema[]) => {
	switch (selectedSort) {
		case QuoteSort.PremiumLowHigh: {
			return orderBy(filteredQuotes, 'premiumAmount', 'asc');
		}
		case QuoteSort.PremiumHighLow: {
			return orderBy(filteredQuotes, 'premiumAmount', 'desc');
		}
		case QuoteSort.AnnualLowHigh: {
			return orderBy(filteredQuotes, 'annualLimits.cover', 'asc');
		}
		case QuoteSort.AnnualHighLow: {
			return orderBy(filteredQuotes, 'annualLimits.cover', 'desc');
		}
		default:
			return orderBy(filteredQuotes, 'premiumAmount', 'asc');
	}
};
